import React, { Component } from "react";
import "../../css/tableStyles.css";
import ExpandButton from "./ExpandButton";

const FlexRow = props => {
  return (
    <div className="flexRow rowmain">
      <div className="flexCell fourCols">{props.item.Outlet_Location}</div>
      <div className="flexCell fourCols">{props.item.Description}</div>
      <div className="flexCell fourCols">{props.item.Test_Result}</div>
      <div className="flexCell fourCols">{props.item.Collection_Date}</div>
    </div>
  );
};

class WaterTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false
    };
    this.renderCutoff = this.renderCutoff.bind(this);
    this.renderAllRows = this.renderAllRows.bind(this);
    this.handleClicked = this.handleClicked.bind(this);

    // const sorted = this.props.reports.sort(function(a,b) {
    //     return (a.Test_Result < b.Test_Result) ? 1 : ((b.Test_Result > a.Test_Result) ? -1 : 0)
    // } )
  }

  handleClicked() {
    this.setState({
      clicked: !this.state.clicked
    });
  }

  renderCutoff() {
    return this.props.reports
      .slice(0, 5)
      .map((item, i) => <FlexRow item={item} key={i} />);
  }

  renderAllRows() {
    return this.props.reports.map((item, i) => <FlexRow item={item} key={i} />);
  }

  render() {
    const reports = this.props.reports;
    let cutoff = this.props.reports.length > 5 ? true : false;

    if (reports.length > 0) {
      return (
        <div className="table-wrap table-water">
          <div className="flexTable">
            <div className="flexTableHead fourCols">
              <div className="flexCell fourCols">Location</div>
              <div className="flexCell fourCols">Type</div>

              <div className="flexCell fourCols">
                Result <small>(ppb)</small>
              </div>
              <div className="flexCell fourCols">Sample Date</div>
            </div>

            {(() => {
              if (cutoff && !this.state.clicked) {
                return this.renderCutoff();
              } else if (cutoff && this.state.clicked) {
                return this.renderAllRows();
              } else {
                return this.renderAllRows();
              }
            })()}
            {(() => {
              if (reports.length > 5) {
                return (
                  <ExpandButton
                    length={this.props.reports.length}
                    clicked={this.state.clicked}
                    onStateChange={this.handleClicked}
                  />
                );
              }
            })()}
          </div>
        </div>
      );
    }
    // if (reports.length > 8) {
    //     return (
    //         <div className="table-wrap table-water">
    //         <div className="flexTable">
    //             <div className="flexTableHead fourCols">
    //                 <div className="flexCell fourCols">Location</div>
    //                 <div className="flexCell fourCols">Description</div>
    //
    //                 <div className="flexCell fourCols">Test Result</div>
    //                 <div className="flexCell fourCols">Water Date</div>
    //             </div>
    //
    //             {
    //                 (() => {
    //                     if (cutoff && !this.state.clicked) {
    //                         return this.renderCutoff()
    //                     } else if (cutoff && this.state.clicke) {
    //                         return this.renderAllRows()
    //                     } else {
    //                         return this.renderAllRows()
    //                     }
    //                 })()
    //             }
    //             <ExpandButton length={this.props.reportslength} clicked={this.state.clicked} onStateChange={this.handleClicked}/>
    //
    //         </div>
    //
    //     </div>
    // )
    // }
    // else if (reports.length <= 8 && reports.length > 0) {
    //     return (<div className="table-wrap table-water">
    //         <div className="flexTable">
    //             <div className="flexTableHead fourCols">
    //                 <div className="flexCell fourCols">Location</div>
    //                 <div className="flexCell fourCols">Type</div>
    //
    //                 <div className="flexCell fourCols">Test Result</div>
    //                 <div className="flexCell fourCols">Sample Date</div>
    //             </div>
    //
    //             {
    //                 (() => {
    //                     if (cutoff && !this.state.clicked) {
    //                         return this.renderCutoff()
    //                     } else if (cutoff && this.state.clicke) {
    //                         return this.renderAllRows()
    //                     } else {
    //                         return this.renderAllRows()
    //                     }
    //                 })()
    //             }
    //
    //         </div>
    //
    //     </div>)
    // }
    else {
      return (
        <div className="noreports">
          All water outlets passed the most recent round of testing.
        </div>
      );
    }
  }
}

export default WaterTable;



// WEBPACK FOOTER //
// ./src/components/tables/WaterTable.js